import { observer } from "mobx-react";
import { NumberQuestion } from "../common/commonComponents";
import { VBox } from "../../components-v2/Box";
import { FC } from "react";
import {
  ContributionPerShareTypeModel,
  IncreaseOfShareCapitalForm,
} from "./increaseOfShareCapitalDomain";

import { CURRENCY_NOK } from "../../utils/currency";

import { useTranslation } from "../../stores/RootStoreContext";

export const IncreaseContributionPerShare: FC<{ model: ContributionPerShareTypeModel }> = observer(
  ({ model }) => {
    const { t } = useTranslation();
    return (
      <>
        <NumberQuestion
          question={t(
            "decisions.increaseShareCapitalAgainstCash.increaseNominalValue.shareContribution",
            {
              shareClassName: t(model.sharetypeLabel).toLowerCase(),
            },
          )}
          prefix={CURRENCY_NOK}
          field={model.contributionPerShare}
          isLocked={model.isProjectLocked}
        />
      </>
    );
  },
);
export const IncreaseNominalValueShareContribution: FC<{
  form: IncreaseOfShareCapitalForm;
}> = observer(({ form }) => {
  return (
    <VBox>
      {form.increaseNominalValue.contributionPerShareTypes.map((s) => (
        <IncreaseContributionPerShare key={s.data.sharetypeId} model={s} />
      ))}
    </VBox>
  );
});
